import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
import { useContext, useEffect, useState } from "react";
import UserContext from "../contexts/UserContext";
import { signInWithEmail, signInWithGoogle, resetPassword, validateEmail } from "../util/helpers";
import { IconButton, TextField, Typography, Alert, CircularProgress } from "@mui/material";
import googleLoginLogo from "../assets/google-signin.png";
function Login(props) {
  const navigate = useNavigate();
  const { authed, refreshUser, user } = useContext(UserContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
  const [resetEmailSent, setResetEmailSent] = useState(false);
  const [resetError, setResetError] = useState("");
  const [isResetting, setIsResetting] = useState(false);
  useEffect(() => {
    if (authed) {
      const path = user.type === "creator"? "/creators" : "/dashboard";
      navigate((path));
    }
  }, [authed, user, navigate]);
  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <Typography
        sx={{ textAlign: "center" }}
        style={{ fontWeight: 600 }}
        variant="h4"
      >
        {forgotPasswordMode ? "Reset Password" : "Brand Login"}
      </Typography>
      <br />

      {forgotPasswordMode ? (
        <>
          {resetEmailSent ? (
            <Alert severity="success" sx={{ width: "100%", marginBottom: 2 }}>
              Password reset email sent! Check your inbox and follow the instructions to reset your password.
            </Alert>
          ) : (
            <>
              <Typography sx={{ textAlign: "left", marginBottom: 1 }}>
                Enter your email address and we'll send you a link to reset your password.
              </Typography>
              {resetError && (
                <Alert severity="error" sx={{ width: "100%", marginBottom: 2 }}>
                  {resetError}
                </Alert>
              )}
              <Typography sx={{ textAlign: "left" }}>Email</Typography>
              <TextField
                type="email"
                fullWidth
                style={{ marginBottom: 10 }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <br />
              <Button
                appearance="default"
                marginTop={10}
                disabled={isResetting}
                onClick={async () => {
                  setResetError("");
                  if (!email || !validateEmail(email)) {
                    setResetError("Please enter a valid email address");
                    return;
                  }
                  setIsResetting(true);
                  try {
                    await resetPassword(email);
                    setResetEmailSent(true);
                  } catch (err) {
                    if (err.code === "auth/user-not-found") {
                      setResetError("No account found with this email address");
                    } else {
                      setResetError("An error occurred. Please try again.");
                    }
                  } finally {
                    setIsResetting(false);
                  }
                }}
                style={{ width: "100%", margin: "0 auto" }}
              >
                {isResetting ? <CircularProgress size={20} color="inherit" /> : "Send Reset Link"}
              </Button>
            </>
          )}
          <Typography
            variant="body2"
            sx={{ textAlign: "center", marginTop: 2 }}
            style={{ fontWeight: 600 }}
          >
            <span
              style={{ cursor: "pointer", color: "#004bb9" }}
              onClick={() => {
                setForgotPasswordMode(false);
                setResetEmailSent(false);
                setResetError("");
              }}
            >
              Back to Login
            </span>
          </Typography>
        </>
      ) : (
        <>
          <Typography sx={{ textAlign: "left" }}>Email</Typography>
          <TextField
            type="email"
            style={{ width: 350, marginBottom: 10 }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <br />
          <Typography sx={{ textAlign: "left" }}>Password</Typography>
          <TextField
            type="password"
            style={{ width: 350, marginBottom: 10 }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Typography
            variant="body2"
            sx={{ textAlign: "right", width: 350, marginBottom: 1 }}
          >
            <span
              style={{ cursor: "pointer", color: "#004bb9" }}
              onClick={() => setForgotPasswordMode(true)}
            >
              Forgot Password?
            </span>
          </Typography>
          <Button
            appearance="default"
            marginTop={10}
            onClick={async () => {
              try {
                await signInWithEmail(email, password);
                await refreshUser(user);
                navigate("/campaigns");
              } catch (err) {
                alert(err);
              }
            }}
            style={{ width: 350, margin: "0 auto" }}
          >
            Login with email
          </Button>
        </>
      )}
      {!forgotPasswordMode && (
        <>
          <hr
            style={{
              width: 350,
              height: 1,
              border: 0,
              borderTop: "1px solid #ccc",
              padding: 0,
            }}
          />

          <IconButton
            appearance="default"
            marginTop={10}
            disableRipple
            onClick={async () => {
              try {
                const result = await signInWithGoogle(email, password);
                await refreshUser(result, true);
                navigate("/dashboard");
              } catch (err) {
                alert(err);
              }
            }}
            style={{ width: 200, marginLeft: 75 }}
          >
            <img
              src={googleLoginLogo}
              style={{ objectFit: "contain" }}
              width="200px"
              alt="Sign in with Google"
            ></img>
          </IconButton>
          <Typography
            variant="body2"
            sx={{ textAlign: "center" }}
            style={{ fontWeight: 600 }}
          >
            Don't have an account?{" "}
            <span
              style={{ cursor: "pointer", color: "#004bb9" }}
              onClick={() => navigate("/register")}
            >
              {" "}
              Sign up now
            </span>
          </Typography>
          <Typography
            variant="body2"
            sx={{ textAlign: "center", marginTop: 2 }}
            style={{ fontWeight: 600 }}
          >
            Are you a creator?{" "}
            <span
              style={{ cursor: "pointer", color: "#004bb9" }}
              onClick={() => navigate("/creatorlogin")}
            >
              Login here
            </span>
          </Typography>
        </>
      )}
    </div>
  );
}

export default Login;
